<template>
    <q-form @submit.prevent="handleSubmit">
      <div class="g-recaptcha" :data-sitekey="siteKey" ref="recaptchaContainer"></div>
      <q-btn class="q-mt-md" type="submit" color="positive" :label="'Continue'" />
    </q-form>
  </template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useQuasar } from 'quasar';

const siteKey = '6LcIoyUqAAAAAMW6c5EWQTuyriiMwExb4h8Nnjb-'; 
const recaptchaContainer = ref(null);
const emit = defineEmits(["goAhead"])
const $q = useQuasar();

const handleSubmit = () => {
  const response = grecaptcha.getResponse();
  if (response.length === 0) {
    $q.notify({type:"warning",message:"Please complete the reCAPTACHA"})
  } else {
    emit("goAhead", response);
  }
};

onMounted(() => {
  const script = document.createElement('script');
  script.src = 'https://www.google.com/recaptcha/api.js';
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);

  script.onload = () => {
    grecaptcha.ready(() => {
      if (recaptchaContainer.value) {
        if (grecaptcha.getResponse()) {
          grecaptcha.reset();
        }
        grecaptcha.render(recaptchaContainer.value, {
          sitekey: siteKey,
          callback: handleSubmit,
          'expired-callback': () => {
            console.log('reCAPTCHA expired');
          },
          'error-callback': (error) => {
            console.error('reCAPTCHA error:', error);
          },
        });
      }
    });
  };
});

onBeforeUnmount(() => {
  if (grecaptcha && grecaptcha.getResponse()) {
    grecaptcha.reset();
  }
});
</script>
